<template>
  <svg xmlns="http://www.w3.org/2000/svg" height="100%" viewBox="0 0 29.75 29.75">
    <g id="Credit_Card_Icon" data-name="Credit Card Icon" transform="translate(-94 -338.473)">
      <path
        id="Path_35"
        data-name="Path 35"
        d="M27.87,14.44H23.662l1.607-.928a1.882,1.882,0,0,0,.688-2.568l-4.942-8.56L20.9,2.191,20.181.941A1.88,1.88,0,0,0,17.613.253L8.657,5.424a.436.436,0,0,0,.436.755l8.956-5.171a1.009,1.009,0,0,1,1.377.369l.5.873L1.511,12.884l-.5-.873a1.008,1.008,0,0,1,.369-1.377L7.53,7.081a.436.436,0,0,0-.436-.755L.941,9.879a1.88,1.88,0,0,0-.688,2.568L.974,13.7h0l.722,1.25,4.332,7.5a1.881,1.881,0,0,0,.71.7v4.72a1.882,1.882,0,0,0,1.88,1.88H21.791a.436.436,0,1,0,0-.872H8.618A1.009,1.009,0,0,1,7.61,27.871V22.89s0-.01,0-.015V16.319a1.009,1.009,0,0,1,1.008-1.008H27.87a1.009,1.009,0,0,1,1.008,1.008V27.871a1.009,1.009,0,0,1-1.008,1.008H23.535a.436.436,0,0,0,0,.872H27.87a1.882,1.882,0,0,0,1.88-1.88V16.319A1.882,1.882,0,0,0,27.87,14.44ZM20.366,3l.153.265.374.647L2.474,14.551l-.527-.912ZM6.739,16.319v5.618L2.91,15.306,21.328,4.672,25.2,11.38a1.009,1.009,0,0,1-.369,1.377L21.919,14.44H8.618a1.882,1.882,0,0,0-1.88,1.88Z"
        transform="translate(94 338.472)"
      />
      <path
        id="Path_36"
        data-name="Path 36"
        d="M308.286,151.174a.436.436,0,0,0-.6-.16l-4.168,2.406a.436.436,0,1,0,.436.755l4.168-2.407A.436.436,0,0,0,308.286,151.174Z"
        transform="translate(-191.682 196.288)"
      />
      <path
        id="Path_37"
        data-name="Path 37"
        d="M365.234,180.463a.436.436,0,1,0-.436-.755l-1.667.963a.436.436,0,1,0,.436.755Z"
        transform="translate(-247.826 169.261)"
      />
      <path
        id="Path_38"
        data-name="Path 38"
        d="M348.81,301.007h4.846a.9.9,0,0,0,.9-.9v-1a.9.9,0,0,0-.9-.9H348.81a.9.9,0,0,0-.9.9v1A.9.9,0,0,0,348.81,301.007Zm-.029-1.9a.029.029,0,0,1,.029-.029h4.846a.029.029,0,0,1,.029.029v1a.029.029,0,0,1-.029.029H348.81a.029.029,0,0,1-.029-.029Z"
        transform="translate(-233.694 57.59)"
      />
      <path
        id="Path_39"
        data-name="Path 39"
        d="M154.794,285.464v-2.921a.9.9,0,0,0-.9-.9h-3.883a.9.9,0,0,0-.9.9v2.921a.9.9,0,0,0,.9.9h3.883A.9.9,0,0,0,154.794,285.464Zm-.872-2.921v1.025h-1.535v-1.054h1.506A.029.029,0,0,1,153.923,282.544Zm-3.912-.029h1.506v1.054h-1.535v-1.025A.029.029,0,0,1,150.011,282.515Zm-.029,2.95V284.44h3.941v1.025a.029.029,0,0,1-.029.029h-3.883A.029.029,0,0,1,149.982,285.464Z"
        transform="translate(-46.446 73.194)"
      />
      <path
        id="Path_40"
        data-name="Path 40"
        d="M149.546,430.743a.436.436,0,0,0,0,.872h1.925a.436.436,0,0,0,0-.872Z"
        transform="translate(-46.446 -67.242)"
      />
      <path
        id="Path_41"
        data-name="Path 41"
        d="M215.812,431.615h5.776a.436.436,0,1,0,0-.872h-5.776a.436.436,0,1,0,0,.872Z"
        transform="translate(-108.862 -67.242)"
      />
      <path
        id="Path_42"
        data-name="Path 42"
        d="M348.345,431.615h2.888a.436.436,0,1,0,0-.872h-2.888a.436.436,0,1,0,0,.872Z"
        transform="translate(-233.694 -67.242)"
      />
    </g>
  </svg>
</template>
<script>
export default {
  name: "M4CreditCardSvg"
};
</script>
